import React from 'react';
import PropTypes from 'prop-types';
import { hasChildren } from '../../helpers';
const SubMenu = ({
  children,
  modifier
}) => {
  const hasValidChildren = hasChildren(children);
  if (!hasValidChildren) return null;
  return /*#__PURE__*/React.createElement("ul", {
    className: modifier
  }, children);
};
SubMenu.propTypes = {
  modifier: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
SubMenu.defaultProps = {
  modifier: '',
  children: null
};
export default SubMenu;
//# sourceMappingURL=SubMenu.js.map